(function () {'use strict';}());

angular.module('app').filter('goals', function() {
    return function(listing) {
    	if(!listing) return listing;
        var trace = angular.trace;
    	var results = [];

    	for(var i = 0, count = listing.length; i < count; i++)
    	{
            var item = listing[i];
            if(item.cgid) results.push(item);
    	}

    	return results;
    };
});